/* eslint-disable no-useless-catch */
import { serialize } from 'utils/crud';

import { entityService } from './services';
// #endregion Local Imports

const pathname = '/entity-location-free-ship';

export const EntityLocationFreeShipApi = {
  createMulti: async (body: any) => {
    try {
      const response = await entityService.post(`${pathname}/multi`, body);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  filter: async (option: EntityLocationFreeShipQuery) => {
    let url = `${pathname}/filter`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  removeMulti: async (ids: string[]) => {
    const url = `${pathname}/multi/remove-entity-location-free-ship`;

    try {
      const response = await entityService.patch(url, {
        entityLocationFreeShipIDs: ids,
      });
      return response;
    } catch (error) {
      throw error;
    }
  },

  removeAllByOwnerID: async () => {
    const url = `${pathname}/remove-all-entity-location-free-ship`;

    try {
      const response = await entityService.patch(url);
      return response;
    } catch (error) {
      throw error;
    }
  },
};

export interface EntityLocationFreeShipQuery {
  order?: any;
  page?: number;
  take?: number;
  skip?: number;
  tab?: string;
  reserved?: boolean;
  ownerID?: string;
}
